import FilterHelper from "../../helpers/filterHelper";
import { formatQueryStringURL } from "../../helpers/formatQueryStringHelper";
import { axiosGet, axiosPost, axiosPut } from "../../services/axiosService";

const basePromotionalCode = 'promoCodes';

export class PromotionalCodeService {
  getCodes(currentPage = 1, perPage = 10, filter) {
    let params = `?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}${filter ? `&${FilterHelper.mapToParams(filter, false)}` : ''
      }`;
    params = formatQueryStringURL(params);
    return axiosGet(null, basePromotionalCode + params);
  }

  getCodeDetail(id) {
    return axiosGet(null, `${basePromotionalCode}/${id}`);
  }

  activateDeactivate(status, id) {
    return axiosPut({}, `${basePromotionalCode}/${id}/activation?isActive=${status}`);
  }

  addCode(values) {
    return axiosPost(values, basePromotionalCode);
  }

  updateCode(id, values) {
    return axiosPut(values, `${basePromotionalCode}/${id}`);
  }
}